import React from "react";
import Colors from "../../Constants/Colors";
import GiftListRender from "./GiftListRender";
import EmptyData from "../EmptyData/EmptyData";

function GiftSessionList({
  data,
  sessionId,
  user,
  astrologer,
  dateTime,
  sessionType,
  duration,
  fees,
  totalfees,
  status,
  commentsContainerRef,
  handleScroll,
}) {
  return (
    <div
      style={{
        alignSelf: "stretch",
        borderRadius: "8px",
        border: Colors.darkBorderColor,
        overflow: "hidden",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <div
        style={{
          alignSelf: "stretch",
          flex: 1,
          backgroundColor: Colors.borderColor,
          borderBottom: Colors.darkBorderColor,
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "space-between",
          padding: "1rem",
          gap: "0.5rem",
        }}
      >
        <div style={{ width: "25%" }} className="contentName">
          {sessionId}
        </div>
        <div style={{ width: "20%" }} className="contentName">
          {user}
        </div>
        <div style={{ width: "20%" }} className="contentName">
          {astrologer}
        </div>
        <div style={{ width: "25%" }} className="contentName">
          {dateTime}
        </div>
        <div style={{ width: "10%" }} className="contentName">
          {fees}
        </div>
        
      </div>
      <div
        // style={{ maxHeight: "75vh" }}
         style={{ maxHeight: "calc(100vh - 16vh)" }}
        ref={commentsContainerRef}
        onScroll={handleScroll}
        className="scrollable-container"
      >
        {data.map((session, index) => (
          <GiftListRender key={index} session={session} />
        ))}
      </div>

    </div>
  );
}

export default GiftSessionList;
